import { React, useState } from "react";
import axios from "axios";
import { Dialog, DialogTitle } from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

function CompanyPaymentUpdate({
  company,
  updateTable,
  setUpdateTable,
  setOpenSnackbar,
  setSnackbarMessage,
}) {
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [openDialog, setOpenDialog] = useState(false);

  const handleCapturePaymentDate = (event) => {
    event.preventDefault();

    if (isNaN(paymentDate.getTime())) {
      setSnackbarMessage("Invalid billing date. Please enter a valid date.");
      setOpenSnackbar(true);
      return;
    }

    const formatDate = paymentDate.toISOString().split("T")[0];

    const formData = new FormData();
    formData.append("employerId", company.employerId);
    formData.append("billingDate", "");
    formData.append("paymentDate", formatDate);

    axios.post("/company/editCompanyBilling", formData).then((res) => {
      if (res.data.success) {
        setSnackbarMessage(`Payment date captured as ${formatDate}`);
        setOpenSnackbar(true);
        setUpdateTable(!updateTable);
        setOpenDialog(false); // Close the dialog after success
      } else {
        setSnackbarMessage(
          `Failed to capture payment date. ${res.data.message}`
        );
        setOpenSnackbar(true);
      }
    });
  };

  return (
    <>
      <Tooltip title="Update payment information">
        <button onClick={() => setOpenDialog(true)}>
          <PaidIcon fontSize="large" className="fill-brand-quaternary" />
        </button>
      </Tooltip>

      <Dialog
        open={openDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            height: "auto", // Automatically adjust height
            maxHeight: "80vh", // Optional: Ensure it doesn't grow too large
          },
        }}>
        <DialogTitle className="mx-auto text-2xl font-bold font-brand-primary">
          Save Company Payment Date
        </DialogTitle>

        <div className="flex items-center justify-center flex-wrap mb-4 mx-8 space-x-4">
          {" "}
          {/* Single row with wrapping */}
          <input
            type="date"
            value={paymentDate.toISOString().split("T")[0]} // Format the date in YYYY-MM-DD format
            onChange={(e) => {
              const inputValue = e.target.value;
              const parsedDate = new Date(inputValue);
              if (!isNaN(parsedDate.getTime())) {
                setPaymentDate(parsedDate);
              }
            }}
            className="w-fit border border-black rounded px-2 py-1"
          />
          <button
            className="primary-button bg-brand-secondary mb-2 h-11 px-4"
            onClick={handleCapturePaymentDate}>
            Save Payment Date
          </button>
          <button
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => setOpenDialog(false)}>
            Cancel
          </button>
        </div>
      </Dialog>
    </>
  );
}

CompanyPaymentUpdate.propTypes = {
  company: PropTypes.shape({
    billingAddress: PropTypes.string,
    billingDate: PropTypes.string,
    companyAddress: PropTypes.string,
    description: PropTypes.string,
    employerId: PropTypes.number,
    endDate: PropTypes.string,
    membership: PropTypes.shape({
      cost: PropTypes.number,
      membershipType: PropTypes.string,
    }),
    name: PropTypes.string,
    paymentDate: PropTypes.string,
    startDate: PropTypes.string,
    status: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
  updateTable: PropTypes.func.isRequired,
  setUpdateTable: PropTypes.func.isRequired,
  setOpenSnackbar: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
};

export default CompanyPaymentUpdate;
